//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { fetch } from '@/page/index'
import SrmCommonUtils from '@/utils/SrmCommonUtils'

export default {
  name: 'DeliveryList',
  data () {
    return {
      deliveries: [],
      formParams: {},
      pageIndex: 1,
      pageRows: 10,
      refreshing: false,
      finished: false,
      loading: false,
      showMoreFormParams: false,
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
    }),
    isSupplier () {
      return this.userInfo && this.userInfo.userType === 'EXTERNAL'
    },
  },
  created () {
    this.onRefresh()
  },
  methods: {
    dv (v) {
      if (v === null || v === undefined || v === '') return '-'
      return String(v)
    },
    lookup (type, v) {
      if (v === null || v === undefined || v === '') return '-'
      const t = new SrmCommonUtils(this).getLookupMeaning(type, v)
      return t != null && t !== '' ? t : String(v)
    },
    isResOk (res) {
      return res && (res.code === '200' || res.code === 200 || res.status === 'S')
    },
    buildListParams () {
      const params = {
        lan: this.languageCode || 'CN',
        pageIndex: this.pageIndex,
        pageRows: this.pageRows,
        ...this.formParams,
      }
      if (this.isSupplier && this.userInfo && this.userInfo.supplierId) {
        params.supplierId = this.userInfo.supplierId
      }
      return params
    },
    onRefresh () {
      this.refreshing = true
      this.loading = true
      this.finished = false
      this.pageIndex = 1
      this.deliveries = []
      this.requestDeliveries()
    },
    onLoad () {
      if (!this.refreshing) {
        this.requestDeliveries()
      }
    },
    closeMoreParams () {
      this.formParams = {}
    },
    searchNoteList () {
      this.showMoreFormParams = false
      this.onRefresh()
    },
    requestDeliveries () {
      fetch
        .srmPurDeliveryNoteHeader_listByPage(this.buildListParams())
        .then((res) => {
          if (!this.isResOk(res)) {
            if (this.pageIndex === 1) this.deliveries = []
            this.finished = true
            return
          }
          const list = Array.isArray(res.data) ? res.data : []
          if (this.pageIndex === 1) {
            this.deliveries = list
          } else {
            this.deliveries = this.deliveries.concat(list)
          }
          const page = res.page || {}
          if (this.deliveries.length < (page.count || 0) && page.nextIndex) {
            this.pageIndex = page.nextIndex
            this.finished = false
          } else {
            this.finished = true
          }
        })
        .catch(() => {
          if (this.pageIndex === 1) this.deliveries = []
          this.finished = true
        })
        .finally(() => {
          this.refreshing = false
          this.loading = false
        })
    },
    onClickDelivery (row) {
      if (!row || !row.noteHeaderId) return
      this.$router.push({
        path: '/Delivery',
        query: { noteHeaderId: String(row.noteHeaderId) },
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/page/srm/delivery/deliveryList.vue